import { SVGProps } from "react";

export function CantDeleteIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="23px"
      height="23px"
      {...props}
    >
      <path
        fill="gray"
        d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"
      ></path>
      <line
        x1="4"
        y1="4"
        x2="20"
        y2="20"
        stroke="gray"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
